import React from "react";
import LegalPageLayout from "@/components/site/LegalPageLayout";

const Section = ({ n, title, children }) => (
  <section className="mt-8">
    <h2 className="font-heading text-xl font-bold text-slate-950 mb-3">
      {n}. {title}
    </h2>
    <div className="space-y-3 text-sm sm:text-base">{children}</div>
  </section>
);

export default function Refund() {
  return (
    <LegalPageLayout
      testId="refund-page"
      title="Refund & Cancellation Policy"
      subtitle="This policy applies to lead-generation, site-visit and report-submission fees agreed between Rana Associates and its partner banks/NBFCs, as well as to executive payouts."
      lastUpdated="22 February 2026"
    >
      <Section n="1" title="Cancellation of a Valuation Request">
        <p>A bank may cancel a valuation request free of charge <b>before</b> the assigned Field Executive begins the site visit. Cancellations must be raised from the bank's dashboard or via <a href="mailto:support@ranaassociate.com" className="text-amber-700 underline">support@ranaassociate.com</a>.</p>
        <p>If the executive has already been dispatched or is on-site, a partial fee of 40% of the report cost is chargeable to cover the visit.</p>
        <p>If the site visit is complete and the report is submitted, the full per-report fee applies and is <b>non-refundable</b>.</p>
      </Section>

      <Section n="2" title="Rejected or Disputed Reports">
        <p>If a bank rejects a report on grounds of factual inaccuracy or incompleteness, the executive will re-visit and correct the report at no additional cost, provided the rejection is raised within 5 business days of submission.</p>
        <p>If rejection is due to a change of instruction by the bank (e.g., different property, wider scope), a fresh fee applies.</p>
      </Section>

      <Section n="3" title="Executive Payouts">
        <p>Executive payouts are credited within 15 days after report acceptance by the bank. Payouts are non-refundable to the executive once disbursed.</p>
        <p>Missed visits, fraudulent inputs or verifiable executive misconduct will result in forfeiture of the specific report's payout and possible de-listing.</p>
      </Section>

      <Section n="4" title="Duplicate Payments">
        <p>Any duplicate or erroneous payment made by a bank will be refunded within 7 business days upon written notification, without any deduction.</p>
      </Section>

      <Section n="5" title="Refund Method">
        <p>Approved refunds are credited back to the original payment source (NEFT/RTGS/UPI) within 7–10 business days from approval.</p>
      </Section>

      <Section n="6" title="How to Raise a Refund Request">
        <p>Email <a href="mailto:accounts@ranaassociate.com" className="text-amber-700 underline">accounts@ranaassociate.com</a> from your registered bank email with the lead ID(s), invoice number and reason. We will acknowledge within 2 business days and resolve within 10 business days.</p>
      </Section>

      <Section n="7" title="Escalation">
        <p>Unresolved refund matters may be escalated to the Grievance Officer at <a href="mailto:grievance@ranaassociate.com" className="text-amber-700 underline">grievance@ranaassociate.com</a>.</p>
      </Section>
    </LegalPageLayout>
  );
}
